<template>
    <div class="fullHeight">
        <MypageSideMenu :memberDropClose="false"/>
        <Card
        :page_title="page_title"
        iconclass="icon-icon-info-profile mypage-title-icon"
        >
            <!-- 初期表示のゴルフ場一覧 -->
            <div class="col-sm-12 p-0" v-show="show_golf_list_flg === true">
                <div class="col-sm-12">

                    <p class="text-left mt-3 h4 visit-h3-boder-left">ご利用ゴルフ場</p>

                    <template v-if="show_golf_list_count_flg == true">
                        <label class="text-left my-2 ">ご利用になるゴルフ場をクリックしてください。</label>

                        <div class="col-12 p-0 mt-4">
                            <template v-for="data in golf_course" >
                                <template v-if="data.api_url != undefined && data.api_url != '' && data.api_url != null">
                                    <button
                                        type="button"
                                        class="visit-golf-list-btn py-2 px-2 m-0 mb-3 row"
                                        @click="selectGolf(data.api_url, data.api_key, data.api_office_code)"
                                        :key="data.golf_code"
                                    >

                                        <div class="visit-golf-list-name p-0">
                                            <p class="h5">{{data.golf_name}}</p>
                                        </div>
                                        <div class="visit-golf-list-info row m-0 p-0">
                                            <div class="visit-golf-list-img p-0" v-show="( data.golf_course_img_path != undefined && data.golf_course_img_path != '' && data.golf_course_img_path != null )">
                                                <img :src="data.golf_course_img_path">
                                            </div>
                                            <div class="visit-golf-list-address row m-0 p-0 pl-2 text-left" v-bind:class="{ 'golf_no_image' : ( data.golf_course_img_path == undefined || data.golf_course_img_path == '' || data.golf_course_img_path == null ) }">

                                                <div class="visit-golf-list-add">
                                                    <label class="px-2 m-0 text-light label-color">住所</label>
                                                    <p class="mb-2">{{data.prefecture_name}}{{data.municipality_name}}{{data.local_name}}{{data.building_name}}</p>
                                                </div>

                                                <div class="visit-golf-list-tel">
                                                    <label class="px-2 m-0 text-light label-color">電話番号</label>
                                                    <p class="mb-2">{{data.telephone}}</p>
                                                </div>

                                            </div>

                                            <div class="visit-golf-list-arrow">
                                                <div class="visit-arrow-icon"></div>
                                            </div>
                                        </div>

                                    </button>
                                </template>
                            </template>
                        </div>
                    </template>
                    <template v-else>
                        <label class="text-left my-3">ご利用になれるゴルフ場がありません。</label>
                    </template>
                    <button
                        type="button"
                        class="my-3 mypagebackbutton footer-btn-size"
                        @click="myPage">
                        マイページトップに戻る
                    </button>
                </div>
            </div>

            <!-- ここにコンテンツが表示される -->
            <slot></slot>
        </Card>
        <MypageMenuFooter/>
        <ErrorDialog
            v-show="now_show_error"
            v-bind:errorWording="error_message"
            v-on:closeErrorDialog="closeErrorDialog"
        ></ErrorDialog>
        <ConfirmDialog
            v-if="now_add_dia_log === true"
            :initialMessage="add_dia_log_message"
            :doing="add_dia_log_doing"
            notDoing="閉じる"
            :processing="processing"
            @from-Dialog="registProce"
            @closeBtn="addOverlayHidden"
        />
    </div>
</template>
<script>
/**
 * 無人チェックイン共通画面表示項目
 */
import MypageSideMenu from '../../mypage/MypageSideMenu';
import MypageHeader from '../../mypage/MypageHeader';
import MypageVisitModal from './MypageVisitModal';
import ErrorDialog from '../ErrorDialog';
import ConfirmDialog from '../ConfirmDialog';
import Card from '../Card';
import MypageMenuFooter from '../../mypage/MypageMenuFooter';

export default {
    components: {
        MypageSideMenu,
        MypageMenuFooter,
        MypageHeader,
        MypageVisitModal,
        ErrorDialog,
        ConfirmDialog,
        Card,
    },
    props: {
        page_title: {
            type: String,
            required: true,
        },
        icon_class: {
            type: String,
            required: false
        },
        show_error: {
            type: Boolean,
            required: false,
        },
        error_message: {
            type: String,
            required: false,
        },
        error_level: {
            type: String,
            required: false,
        },
        my_page_btn_flg: {
            type: Boolean,
            required: false,
        },
        add_dia_log: {
            type: Boolean,
            required: false,
        },
        add_dia_log_message: {
            type: String,
            required: false,
        },
        add_dia_log_doing: {
            type: String,
            required: false,
        },
        registProce: {
            type: Function,
            required: false,
        },
        golf_course: {
            type: Array,
            required: false,
        },
        show_golf_list_flg: {
            type: Boolean,
            required: false,
        },
        selectGolf: {
            type: Function,
            required: false,
        },
        show_golf_list_count_flg: {
            type: Boolean,
            required: false,
        },
    },
    data () {
        return {
            // 処理の結果のオブジェクト
            processing: {
                result: '',
                resultText: '',
                btnDisabled: 0,
            },
        };
    },
    /** ----------------------------------------------
     * エラーダイアログの情報を親とやり取り
     * ---------------------------------------------- */
    computed: {
        now_show_error: {
            get() {
                return this.show_error;
            },
            set(newValue) {
                this.$emit('update:show_error', newValue);
            }
        },
        now_add_dia_log: {
            get() {
                return this.add_dia_log;
            },
            set(newValue) {
                this.$emit('update:add_dia_log', newValue);
            }
        },
        now_show_golf_list_flg: {
            get() {
                return this.show_golf_list_flg;
            },
            set(newValue) {
                this.$emit('update:show_golf_list_flg', newValue);
            }
        }
    },
    methods: {
        /** ----------------------------------------------
         * エラーダイアログを閉じる
         * ---------------------------------------------- */
        closeErrorDialog () {
            // エラー
            if(this.error_level == "crit"){
                if(this.my_page_btn_flg == true){
                    // マイページへ遷移
                    this.myPage();
                }else{
                    this.$router.push({ path: '/mypage-reserve-list' });
                }
                // ローディング非表示
                this.$store.commit("loading/setIsLoading", true);
            }

            // 閉じる
            this.now_show_error = false;
        },
        /** ----------------------------------------------
         * キャンセルダイアログを表示
         * ---------------------------------------------- */
        addOverlayHidden (data) {
          this.now_add_dia_log = !this.now_add_dia_log;
          this.$set(this.processing, 'result', '');
        },
        /** ----------------------------------------------
         * マイページへ遷移
         * ---------------------------------------------- */
        myPage: async function(){
            this.$router.push({ path: '/mypage' });
        },
    },
}
</script>

<style>
.visit-golf-list {
    margin-left: 0.5rem !important;
    margin-right: 0.5rem !important;
    width: 800px;
    padding-right: 10px;
}
.visit-golf-list-img img{
    width: 100%;
    height: 100%;
    max-height: 110px;
    object-fit: cover;
}
.visit-arrow-icon{
    position: absolute;
    top: 50%;
    right: -5px;
    transform: translateY(-50%);
    -webkit-transform: translateY(-50%);
    padding: 0 0 0 23px;
    -ms-transform: translateY(-50%);
    height: 100%;
    width: 100%;
}
.visit-arrow-icon::before,
.visit-arrow-icon::after{
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    content: "";
    vertical-align: middle;
}
.visit-arrow-icon::before{
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    border: 1px solid #cacaca;
    border-radius: 5px;
}
.visit-arrow-icon::after{
    left: 33%;
    width: 9px;
    height: 9px;
    border-top: 2px solid #aaa;
    border-right: 2px solid #aaa;
    transform: rotate(45deg);
}
.visit-golf-list-btn,
.visit-golf-list-arrow,
.visit-golf-list-img,
.visit-golf-list-address,
.visit-golf-list-name,
.visit-golf-list-info,
.visit-golf-list-add ,
.visit-golf-list-tel {
    position: relative;
    width: 100%;
}
.visit-golf-list-btn{
    flex: 0 0 100%;
    max-width: 100%;
}
.visit-golf-list-name {
    flex: 0 0 54%;
    max-width: 54%;
    margin: auto;
    text-align: left;
}
.visit-golf-list-info {
    flex: 0 0 46%;
    max-width: 46%;
}
.visit-golf-list-img {
    display: none;
    flex: 0 0 33%;
    max-width: 33%;
}
.visit-golf-list-address {
    flex: 0 0 90%;
    max-width: 90%;
    font-size: 0.7rem;
}

.visit-golf-list-add{
    flex: 0 0 70%;
    max-width: 70%;
}
.visit-golf-list-tel {
    flex: 0 0 30%;
    max-width: 30%;
}
.visit-golf-list-arrow {
    flex: 0 0 10%;
    max-width: 10%;
}

@media screen and (max-width: 896px) {

    .visit-golf-list {
        margin-left: 0.25rem !important;
        margin-right: 0.25rem !important;
        width: 100%;
    }

    .visit-arrow-icon::before{
        width: 21px;
        height: 86px;
    }
    .visit-arrow-icon::after{
        left: 4px;
    }
    .visit-golf-list-btn,
    .visit-golf-list-name,
    .visit-golf-list-info ,
    .visit-golf-list-add ,
    .visit-golf-list-tel {
        flex: 0 0 100%;
        max-width: 100%;
    }
    .visit-golf-list-name {
        border-bottom: 1px solid #6c757d !important;
        margin: 0 0 15px;
        text-align: center;
    }
    .visit-golf-list-img {
        display: block;
    }
    .visit-golf-list-address:not(.golf_no_image) {
        flex: 0 0 59%;
        max-width: 59%;
    }
    .visit-golf-list-address {
        flex: 0 0 92%;
        max-width: 92%;
    }
    .visit-golf-list-arrow {
        flex: 0 0 8%;
        max-width: 8%;
    }
}

.qr-code {
    height: auto;
    width: 100%;
    max-width: 600px;
    margin:auto;
}
.barcode {
    background-color: white;
    padding-bottom: 15px;
    margin-bottom: 15px;
    padding-top: 15px;
    border-bottom-right-radius: 0.5rem;
    border-bottom-left-radius: 0.5rem;
    text-align: center;
}
.barcode svg {
    width: 100%;
}
</style>
